// API Endpoints
export const API_ENDPOINTS = {
  CREATE_CATEGORY: '/workflows/category/create',
  DELETE_CATEGORY: '/workflows/category/delete',
  CATEGORY_LIST: '/workflows/category/list',

  CREATE_PROMPT: '/portalbuilder/prompt/create',
  UPDATE_PROMPT: '/portalbuilder/prompt/update',
  DELETE_PROMPT: '/portalbuilder/prompt/delete',
  PROMPT_LIST: '/portalbuilder/prompt/list',

  //https://dev-workflowbuilder-api.cdgportal.com/v1/workflows/list

  CREATE_WORKFLOW: '/workflows/rules/create',
  UPDATE_WORKFLOW: '/workflows/rules/update',
  DELETE_WORKFLOW: '/workflows/rules/delete',
  WORKFLOW_RULES_LIST: '/workflows/rules/list',

  WORKFLOW_LIST: '/workflows/list',
  UPLOAD_IMAGE_API: '/portalbuilder/upload/url',
  DOWNLOAD_IMAGE_API: '/portalbuilder/download/url',
  //https://dev-workflowbuilder-api.cdgportal.com/v1/portalbuilder/download/url?wfwId=b7863758-5345-4ea8-be51-1c8f3147ce09&wfwNodeId=_k_YnU9Q8z1C-tstNRSdY&companyId=255

  //https://dev-workflowbuilder-api.cdgportal.com/v1/portalbuilder/upload/url
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

export const AUTH_SDK = {
  NO_ACCESS_MESSAGE : "Sorry, you don't have permission to access this. Please contact the administrator for access."
}

export const AUTH_SDK_MODULES = [
	{
    key: "Wb",
    module: "Workflow Builder Element Access",
    description: "Grants permission to view and use Workflow Builder elements",
    actions: [
      { name: "Launch", description: "Opens the Workflow Builder app to access its features" },
    ],
  }
]